@if (loading) {
  <div class="help-scroll flex-grow-1 d-flex align-items-center justify-content-center p-3">
    <div class="spinner-border spinner-border-sm text-secondary" role="status">
      <span class="visually-hidden">Loading…</span>
    </div>
  </div>
} @else if (failed) {
  <div class="help-scroll flex-grow-1 overflow-auto p-3">
    <p class="text-body-secondary small mb-2">The help contents could not be loaded.</p>
    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="load()">Try again</button>
  </div>
} @else {
  <div class="help-scroll flex-grow-1 overflow-auto p-2" role="tree">
    @for (node of nodes; track node.id) {
      <adf-help-tree-item [node]="node" [openIds]="openIds" />
    }
  </div>

  <!--
    A plain anchor rather than a router link: the target is a static file, not a route. `download`
    asks the browser to save it rather than navigate to it, so the application is never replaced by
    a PDF viewer.
  -->
  <a
    class="help-download border-top d-flex align-items-center gap-2 px-3 py-2 text-decoration-none"
    [href]="pdfHref"
    [download]="pdfFileName"
    title="Download the whole help as a PDF"
  >
    <i class="bi bi-file-earmark-pdf"></i>
    <span>Download as PDF</span>
  </a>
}
